import { render, staticRenderFns } from "./Activated.vue?vue&type=template&id=a49b7ef2&"
import script from "./Activated.vue?vue&type=script&lang=js&"
export * from "./Activated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a49b7ef2')) {
      api.createRecord('a49b7ef2', component.options)
    } else {
      api.reload('a49b7ef2', component.options)
    }
    module.hot.accept("./Activated.vue?vue&type=template&id=a49b7ef2&", function () {
      api.rerender('a49b7ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Activated.vue"
export default component.exports